import React, { useEffect, useState } from 'react';
import httpService from "../../services/httpService";
import Spinner from 'react-bootstrap/Spinner';
import Alert from 'react-bootstrap/Alert';
import PodcasterEpisodeItem from "./PodcasterEpisodeItem";

const ClubEpisodes = ({ clubGuid, onEditEpisode, onViewUsers }) => {
    const [loading, setLoading] = useState(true);
    const [episodes, setEpisodes] = useState([]);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (clubGuid) {
            fetchEpisodes();
        }
    }, [clubGuid]);

    const fetchEpisodes = () => {
        setLoading(true);
        setError(null);

        httpService.get(`/dash/podcast-club/${clubGuid}/episodes`)
            .then((res) => {
                console.log('Club episodes:', res.data);
                setEpisodes(res.data.data || []);
            })
            .catch((err) => {
                console.error('Error fetching episodes:', err);
                setError(err.response?.data?.message || "Error loading episodes");
            })
            .finally(() => setLoading(false));
    };

    if (loading) {
        return (
            <div className="text-center py-4">
                <Spinner animation="border" role="status">
                    <span className="visually-hidden">Loading...</span>
                </Spinner>
                <p className="mt-2">Loading episodes...</p>
            </div>
        );
    }

    if (error) {
        return (
            <Alert variant="danger">
                {error}
            </Alert>
        );
    }

    if (!episodes || episodes.length === 0) {
        return (
            <Alert variant="info">
                No episodes found for this podcast club.
            </Alert>
        );
    }

    return (
        <div className="pt-3 component-ClubEpisodes">
            <h6 className="mb-3">Episodes ({episodes.length})</h6>
            {episodes.map((episode) => (
                <PodcasterEpisodeItem
                    key={episode.id}
                    episode={episode}
                    clubGuid={clubGuid}
                    onEditEpisode={onEditEpisode}
                    onViewUsers={onViewUsers}
                />
            ))}
        </div>
    );
};

export default ClubEpisodes;